import CONSTANT from './constant';
import moment from 'moment';
import * as axios from 'axios';

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function capFirstLetterInSentence(sentence) {
    if (sentence && sentence.length && sentence !== undefined && sentence !== null) {
        let words = sentence.split(" ").map((word) => {
            return word[0].toUpperCase() + word.slice(1);
        })
        return words.join(" ");
    } else {
        return ""
    }

}

export const isImageExist = (ppURL) => {
    return axios.get(ppURL)
        .then((response) => {
            return response.data;
        });
}

export const setsessionStorage = (key, jsonObj) => {
    sessionStorage.setItem(key, JSON.stringify(jsonObj));
}

export const getsessionStorage = (keyName) => {
    const item = sessionStorage.getItem(keyName);
    return JSON.parse(item);
}

export const removeSessionStorage = (keyName) => {
    sessionStorage.removeItem(keyName);
}
export const removeAllSessionStorage = () => {
    sessionStorage.clear();
}

export const removeStorage = (keyName) => {
    localStorage.removeItem(keyName);
}

export const setStorage = (key, jsonObj) => {
    localStorage.setItem(key, JSON.stringify(jsonObj))
}

export const getProfileImage = () => {

    const url = `${process.env.REACT_APP_BASE_URL}/get-profile-image`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })

}

export const getStorage = (keyName) => {
    debugger
    const item = localStorage.getItem(keyName);
    return JSON.parse(item);
}

export const removeAllLocalStorage = () => {
    localStorage.clear();
}

export const onChange = (context, name, newValue, callback) => {
    context.setState({
        [name]: { ...context.state[name], value: newValue }
    }, callback && callback);
}

export const onClear = (context, name) => {
    context.setState({
        [name]: { ...context.state[name], value: '' }
    });
}

export const getAuthHeader = () => {
    const token = getStorage(CONSTANT.keys.token);
    const header = {
        headers: { Authorization: "Bearer " + token }
    };
    return header;
}


export const getDateParts = (input) => {
    const mDate = moment(input);
    return {
        day: mDate.format("ddd"),
        date: mDate.format("DD"),
        month: mDate.format("MM"),
        monthName: mDate.format("MMM"),
        year: mDate.format("YYYY"),
        hour: mDate.format("h"),
        minute: mDate.format("mm"),
        seconds: mDate.format("ss"),
        amOrpm: mDate.format("A"),
        relativeTime: mDate.fromNow()
    };
};

export const getDatePartsUnix = (input) => {
    const mDate = moment.unix(input);
    return {
        day: mDate.format("ddd"),
        date: mDate.format("DD"),
        month: mDate.format("MM"),
        monthName: mDate.format("MMM"),
        year: mDate.format("YYYY"),
        hour: mDate.format("h"),
        minute: mDate.format("mm"),
        seconds: mDate.format("ss"),
        amOrpm: mDate.format("A"),
        relativeTime: mDate.fromNow()
    };
};



export const ToSeoUrl = (url) => {

    // make the url lowercase         
    var encodedUrl = url.toString().toLowerCase();

    // replace & with and           
    encodedUrl = encodedUrl.split(/\&+/).join("-and-")

    // remove invalid characters 
    encodedUrl = encodedUrl.split(/[^a-z0-9]/).join("-");

    // remove duplicates 
    encodedUrl = encodedUrl.split(/-+/).join("-");

    // trim leading & trailing characters 
    encodedUrl = encodedUrl.trim('-');

    return encodedUrl.toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '')
        ;
}
export const setOptions = (context, name, value, callback) => {
    context.setState({
        [name]: { ...context.state[name], options: value }
    }, callback && callback);
}

export const clearForm = (context) => {
    const st = JSON.parse(JSON.stringify(context.state));
    let status = true;
    for (let key in st) {
        if (st.hasOwnProperty(key) && st[key]) {
            const name = st[key].name;
            onClear(context, name)
            setError(context, name, '');
        }
    }
    return status;
}


export const validateForm = (context) => {
    const st = JSON.parse(JSON.stringify(context.state));
    let status = true;
    for (let key in st) {
        if (st.hasOwnProperty(key) && st[key]) {
            const name = st[key].name;
            const isRequired = st[key].isRequired;
            const value = st[key].value;
            if (isRequired && (value === null || value === undefined || value.length === 0)) {
                status = false;
                setError(context, name, 'This field is required');
            } else if (isRequired && value.toString().length > 0) {
                setError(context, name, '');
            }
        }
    }
    return status;
}

export const validForm = (context) => {
    const st = JSON.parse(JSON.stringify(context.state));
    let status = true;
    for (let key in st) {
        if (st.hasOwnProperty(key) && st[key]) {
            const name = st[key].name;
            const isRequired = st[key].isRequired;
            const value = st[key].value;
            if (isRequired && (value === null || value === undefined || value.length === 0)) {
                status = false;
                setError(context, name, ' ');
            } else if (isRequired && value.toString().length > 0) {
                setError(context, name, '');
            }
        }
    }
    return status;
}


export const functionalFormValidation = (context) => {

    const st = JSON.parse(JSON.stringify(context.state));
    let status = true;
    for (let key in st) {
        if (st.hasOwnProperty(key) && st[key]) {
            const name = st[key].name;
            const isRequired = st[key].isRequired;
            const value = st[key].value;
            if (isRequired && (value === null || value === undefined || value.length === 0)) {
                status = false;
                setError(context, name, 'This field is required');

            } else if (isRequired && value.toString().length > 0) {
                setError(context, name, '');
            }
        }
    }
    return status;
}



export const DaysBetween = (StartDate, EndDate) => {
    // The number of milliseconds in all UTC days (no DST)
    const oneDay = 1000 * 60 * 60 * 24;

    // A day in UTC always lasts 24 hours (unlike in other time formats)
    const start = Date.UTC(EndDate.getFullYear(), EndDate.getMonth(), EndDate.getDate());
    const end = Date.UTC(StartDate.getFullYear(), StartDate.getMonth(), StartDate.getDate());

    // so it's safe to divide by 24 hours
    return (start - end) / oneDay;
}

export const setIsRequired = (context, name, bool, callback) => {

    context.setState({
        [name]: { ...context.state[name], isRequired: bool }
    }, callback && callback);
}

export const setError = (context, name, error, callback) => {
    context.setState({
        [name]: { ...context.state[name], error }
    }, callback && callback);
}





export const capitalizeWords = (arr) => {
    return arr.map(element => {
        return element.charAt(0).toUpperCase() + element.substring(1).toLowerCase();
    });
}



export const getRandomColorCSS = (index) => {
    const colorsCSS = [
        "bg-primary",
        "bg-warning",
        "bg-danger",
        "bg-info",
        "bg-secondary",
        "bg-primary",
        "bg-warning",
        "bg-danger",
        "bg-info",
        "bg-secondary",
        "bg-primary",
        "bg-warning",
        "bg-danger",
        "bg-info",
        "bg-secondary",
        "bg-primary",
        "bg-warning",
        "bg-danger",
        "bg-info",
        "bg-secondary",
        "bg-primary",
        "bg-warning",
        "bg-danger",
        "bg-info",
        "bg-secondary",
        "bg-primary",
        "bg-warning",
        "bg-danger",
        "bg-info",
        "bg-secondary",
    ]
    if (index !== undefined && index !== null) {
        return colorsCSS[index];
    }
    return colorsCSS[Math.floor(Math.random() * colorsCSS.length) + 1];
}



export const getRandomColorBtn = (index) => {
    const colorsCSS = [
        "btnnew",
        "btnnew-red",
        "btnnew-blue",
        "btnnew-red",
        "btnnew",
        "btnnew-blue",
        "btnnew",
        "btnnew-red",
        "btnnew-red",
        "btnnew",
        "btnnew-red",
        "btnnew-blue",
        "btnnew-red",
        "btnnew",
        "btnnew-blue",
        "btnnew",
        "btnnew-red",
        "btnnew-red",
        "btnnew",
        "btnnew-red",
        "btnnew-blue",
        "btnnew-red",
        "btnnew",
        "btnnew-blue",
        "btnnew",
        "btnnew-red",
        "btnnew-red",
        "btnnew",
        "btnnew-red",
        "btnnew-blue",
        "btnnew-red",
        "btnnew",
        "btnnew-blue",
        "btnnew",
        "btnnew-red",
        "btnnew-red",

    ]
    if (index !== undefined && index !== null) {
        return colorsCSS[index];
    }
    return colorsCSS[Math.floor(Math.random() * colorsCSS.length) + 1];
}



export function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function numbertoWord(input) {
    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    function inWords(num) {
        if ((num = num.toString()).length > 9) return 'overflow';
        let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return; var str = '';
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
        str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
        return str;
    }
    return inWords(input);

}


export const validateFunctionalForm = (state, setState) => {
    const updatedState = { ...state };
    let status = true;

    Object.keys(updatedState).forEach(key => {
        const field = updatedState[key];
        if (field?.isRequired !== false && field?.isRequired !== true) {

        }
        else if (field?.isRequired) {
            const value = field?.value;

            if (typeof value === 'string' && value.trim() === '') {
                updatedState[key] = { ...field, error: 'This field is required' };
                status = false;
            } else if (Array.isArray(value) && value.length === 0) {
                updatedState[key] = { ...field, error: 'This field is required' };
                status = false;
            } else {
                updatedState[key] = { ...field, error: '' };
            }
        } else {
            updatedState[key] = { ...field, error: '' };
        }
    });

    setState(updatedState);
    return status;
};
